import Infinity from "@material-symbols/svg-500/rounded/all_inclusive.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const InfinityIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Infinity });
	return <Icon />;
};

export default memo(InfinityIcon);
